import { useMemo, type FC } from 'react'

import { Shimmer } from '@wartek-id/shimmer'

import FilterButtons from 'app/KinerjaShared/components/FilterButtons'
import { penilaianStateLabel } from 'app/KinerjaPSPage/utils/states'
import { DeliveryStatus } from 'types/kinerja-ps'

import type { TPenilaianFilterStatus, TPenilaianMeta } from 'types/kinerja-ps'

export type FilterItem = TPenilaianFilterStatus

type FilterItemObj = {
  label: string
  value: FilterItem[]
}

type FilterItems = FilterItemObj[]

type Props = {
  isLoading?: boolean
  counts: TPenilaianMeta['counts']
  activeFilter?: Array<FilterItem>
  onChange?: (value: Array<FilterItem>) => void
  hideBelumDinilai?: boolean
}

export const FilterStatusPengiriman: FC<Props> = ({
  isLoading,
  counts,
  activeFilter,
  onChange,
  hideBelumDinilai = false,
}) => {
  const filterItems: FilterItems = useMemo(() => {
    return [
      { value: ['ALL'] },
      { value: ['BELUM_DIKIRIM'] },
      { value: ['SUDAH_DIKIRIM'] },
      ...(!hideBelumDinilai ? [{ value: ['BELUM_DINILAI'] }] : []),
    ].map((item: FilterItemObj) => {
      const label = penilaianStateLabel(DeliveryStatus?.[item?.value?.[0]])

      const counter = !!counts
        ? item?.value?.reduce((acc, curr) => {
            return acc + counts?.[DeliveryStatus[curr]] || 0
          }, 0)
        : null

      return {
        ...item,
        label: `${label}${counter >= 0 ? ` (${counter || 0})` : ''}`,
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [counts])

  return (
    <div>
      {isLoading && (
        <div className="flex gap-4">
          {Array.from({ length: 4 })?.map((_, index) => (
            <Shimmer
              width={90 + index * 20}
              height={38}
              className="!rounded-full"
              key={index}
            />
          ))}
        </div>
      )}

      {!isLoading && (
        <FilterButtons<TPenilaianFilterStatus[]>
          items={filterItems}
          activeValue={activeFilter}
          btnSize="md"
          onChange={(value) => onChange?.(value)}
        />
      )}
    </div>
  )
}
